import * as React from 'react';
import styles from './index.less';
import { PopoverProps } from 'antd/lib/popover';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';

interface FPopoverPureProps extends PopoverProps {
  open?: boolean;
  content: React.ReactNode;
  children: React.ReactNode;
  placement?: TooltipPlacement;
}

function FPopoverPure({ open, content, children, placement }: FPopoverPureProps) {
  return (<Popover
    className={styles.className}
    overlayClassName={styles.overlayClassName}
    openClassName={styles.openClassName}
    open={open}
    title={null}
    overlayInnerStyle={{ padding: 0 }}
    overlayStyle={{ padding: 0 }}
    style={{ padding: 0 }}
    content={content}
    placement={placement}
  >{children}</Popover>);
}

export default FPopoverPure;
